import { CollapsedFieldRow } from '@liza/ui/components/timing/CollapsedFieldRow';
import { ScheduleEndsFields } from '@liza/ui/components/timing/ScheduleEndsFields';
import { isRecurringScheduleType, type SchedulePickerState, type ScheduleType } from '@liza/ui/utils/schedulePicker';
import { useTranslation } from 'react-i18next';

/** "+ Ends" row wrapping the ends controls for every recurring mode. */
export function EndsRow({
  scheduleType,
  endMode,
  endDate,
  endCount,
  onPatch,
}: {
  scheduleType: ScheduleType;
  endMode: SchedulePickerState['endMode'];
  endDate: string;
  endCount: number;
  onPatch: (patch: Partial<SchedulePickerState>) => void;
}): React.ReactNode {
  const { t } = useTranslation('common');
  if (!isRecurringScheduleType(scheduleType)) return null;
  // Mirrors ScheduleEndsFields' displayMode: an inherited afterCount displays
  // as never on the days-per-week quota, so it must not expand the row either.
  const hasValue = endMode === 'onDate' || (endMode === 'afterCount' && scheduleType !== 'daysPerWeek');
  return (
    <CollapsedFieldRow
      name="ends"
      label={t('endsLabel')}
      hasValue={hasValue}
      onClear={() => onPatch({ endMode: 'never', endDate: '' })}
    >
      <ScheduleEndsFields
        scheduleType={scheduleType}
        endMode={endMode}
        endDate={endDate}
        endCount={endCount}
        onPatch={onPatch}
      />
    </CollapsedFieldRow>
  );
}
